import {
  CountriesQuery,
  useCountriesQuery,
} from "../../../api/backend/backend-api"
import { useLanguageId } from "../../localization/hooks"

export const useCountries = () => {
  const languageId = useLanguageId()
  return useCountriesQuery({
    variables: {
      languageId,
    },
  })
}

export const useStaticCountries = (): CountriesQuery => ({
  countries: {
    default: {
      code: "IT",
      name: "Italia",
      hasProvince: true,
      __typename: "Country",
    },
    values: [
      {
        code: "IT",
        name: "Italia",
        hasProvince: true,
        __typename: "Country",
      },
    ],
  },
})
